import { useState, useEffect } from 'react';
import { sanitizeUrl } from 'shared-widget-components/src/utils/sanitizeUrl';
import { EventSlide } from '../../../../models/slides/EventSlide';
import useEventUrl from './useEventUrl';

interface useEventProps {
  slides: EventSlide[];
  currentIndex: number;
}

export const useEvent = ({ slides, currentIndex }: useEventProps) => {
  const { createUrl } = useEventUrl();

  const [eventData, setEventData] = useState({} as EventSlide);

  //@ts-ignore
  const isAdmin = window.isAdminPage;

  // @ts-ignore
  const languageCode = window.currentLanguageCode;

  // if not on admin page, navigate to the event page on click
  const onEventClick = () => {
    if (isAdmin) return;

    const url = createUrl(eventData.id, eventData.title, languageCode);

    const sanitizedUrl = sanitizeUrl(url);

    window.location.href = sanitizedUrl;
  };

  useEffect(() => {
    if (!slides || !slides[currentIndex]) return;
    setEventData(slides[currentIndex]);
  }, [slides && slides[currentIndex]]);

  return { eventData, onEventClick };
};
